(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloodwork-analyser"] && !Shopify.designMode) return;
  try {
    

const BW_PROXY_URL = 'https://unived-bloodwork-proxy.dp5807.workers.dev';
let bwSelectedFile = null;

// ── File handling ────────────────────────────────────────────────
window.bwFileSelect = function(input) {
  if (input.files && input.files[0]) bwSetFile(input.files[0]);
};

window.bwHandleDrop = function(e) {
  e.preventDefault();
  document.getElementById('bwUploadZone').classList.remove('drag');
  if (e.dataTransfer.files[0]) bwSetFile(e.dataTransfer.files[0]);
};

function bwSetFile(file) {
  bwSelectedFile = file;
  document.getElementById('bwFileLabel').textContent = file.name;
  document.getElementById('bwFileRow').style.display = 'flex';
  document.getElementById('bwUploadZone').style.display = 'none';
  const btn = document.getElementById('bwBtn');
  btn.disabled = false;
  btn.style.opacity = '1';
  btn.style.cursor = 'pointer';
}

window.bwClear = function() {
  bwSelectedFile = null;
  document.getElementById('bwInput').value = '';
  document.getElementById('bwFileRow').style.display = 'none';
  document.getElementById('bwUploadZone').style.display = '';
  const btn = document.getElementById('bwBtn');
  btn.disabled = true;
  btn.style.display = '';
  btn.style.opacity = '.35';
  btn.style.cursor = 'default';
};

window.bwReset = function() {
  window.bwClear();
  ['bwLoadingState','bwResultState','bwErrorState'].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
  });
};

function bwToBase64(file) {
  return new Promise(function(res, rej) {
    const r = new FileReader();
    r.onload = function() { res(r.result.split(',')[1]); };
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

function bwMime(file) {
  if (file.type === 'application/pdf') return 'application/pdf';
  if (file.type.startsWith('image/')) return file.type;
  const ext = file.name.split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'application/pdf';
  if (['jpg','jpeg'].includes(ext)) return 'image/jpeg';
  if (ext === 'png') return 'image/png';
  return 'image/jpeg';
}

// ── EXACT Unived product catalogue (verified) ────────────────────
const BW_PRODUCTS = [
  { id:'d3k2',
    name:'Unived D3+K2-7',
    strength:'600 IU D3 (lichen-sourced) · 33mcg K2-7 (MenaquinGold®)',
    url:'https://www.unived.com/products/d3-k2-7',
    markers:['vitamin d','25-oh','25oh','vitamin d3','25 hydroxy'],
    why:'Plant-based D3 from lichen (Vitashine™) with K2-7 from fermented chickpeas. D3 corrects deficiency; K2-7 directs calcium to bones rather than arteries.'
  },
  { id:'b12d3',
    name:'Unived B12+D3',
    strength:'2.25mcg methylcobalamin · 600 IU D3 (lichen-sourced)',
    url:'https://www.unived.com/products/b12-d3',
    markers:['b12','vitamin b12','cobalamin','vitamin d','25-oh','25oh'],
    why:'Combined methylcobalamin B12 and plant-based D3 — ideal for vegetarians and vegans who commonly lack both. Methylcobalamin is the active neurological form of B12.'
  },
  { id:'iron',
    name:'Unived Iron Bisglycinate',
    strength:'25mg elemental iron (Ferrochel® Albion chelate)',
    url:'https://www.unived.com/products/iron-bisglycinate',
    markers:['ferritin','haemoglobin','hemoglobin','iron','hb','mchc','mcv','tibc','serum iron','rbc'],
    why:'Ferrochel® iron bisglycinate is the most bioavailable and best-tolerated form of iron — clinically proven to correct iron deficiency anaemia without constipation or GI side effects.'
  },
  { id:'mag',
    name:'Unived Chelated Magnesium Glycinate Pure',
    strength:'Non-buffered magnesium bisglycinate chelate',
    url:'https://www.unived.com/products/chelated-magnesium-glycinate-pure',
    markers:['magnesium','rbc magnesium','serum magnesium'],
    why:'Non-buffered chelate form is the most absorbable — supports sleep quality, muscle function, and stress recovery without laxative effect at standard doses.'
  },
  { id:'omega3',
    name:'Unived Ovegha',
    strength:'Vegan algae-derived DHA omega-3',
    url:'https://www.unived.com/products/ovegha',
    markers:['triglycerides','ldl','hdl','cholesterol','tg','omega','dha','lipid'],
    why:'Algae-sourced DHA — the original biosource that fish themselves use. No heavy metal contamination risk. Supports cardiovascular lipid profile and cognitive health.'
  },
  { id:'ashwag',
    name:'Unived Shoden® Ashwagandha',
    strength:'120mg (35% withanolide glycosides)',
    url:'https://www.unived.com/products/shoden-ashwagandha',
    markers:['cortisol','tsh','thyroid','dheas','stress'],
    why:'Shoden® is the highest-potency ashwagandha extract commercially available — 35% withanolide glycosides. Clinically validated for cortisol reduction and stress management.'
  },
  { id:'zinc',
    name:'Unived Zinc',
    strength:'Zinc citrate with Vitamin C and Moringa',
    url:'https://www.unived.com/products/zinc',
    markers:['zinc','serum zinc','testosterone','free testosterone'],
    why:'Zinc citrate is a highly bioavailable form. Combined with Vitamin C for synergistic immune and antioxidant support. Essential for testosterone synthesis, immune function, and wound healing.'
  },
  { id:'curq10',
    name:'Unived CurQ10',
    strength:'306mg fermented CoQ10 · 100mg Curcumin (95% curcuminoids) · Piperine',
    url:'https://www.unived.com/products/curq10',
    markers:['crp','esr','inflammatory','ldl','cholesterol','statin','cardiovascular','joint','uric acid'],
    why:'CurQ10 combines 300mg fermented CoQ10 with 100mg standardised curcumin. CoQ10 is depleted by statins and age. Curcumin blocks COX-2 inflammatory pathways. Piperine enhances absorption of both.'
  },
  { id:'biotin',
    name:'Unived Basics Biotin',
    strength:'Biotin from Sesbania grandiflora · Vitamin C · Zinc · Vitamin E · Vitamin A',
    url:'https://www.unived.com/products/basics-biotin',
    markers:['biotin','hair','keratin','nail'],
    why:'Plant-sourced biotin from Sesbania grandiflora with zinc, vitamin C, and vitamin E — a complete hair, skin, and nail formula targeting multiple keratin synthesis pathways.'
  },
  { id:'pcos',
    name:'Unived PCOS Management',
    strength:'Myo-inositol · D-Chiro Inositol · NAC and supporting nutrients',
    url:'https://www.unived.com/products/pcos-management',
    markers:['insulin','homa','lh','fsh','amh','testosterone','pcos','androgen','dheas'],
    why:'Formulated for PCOS with the clinically validated 40:1 myo:D-chiro inositol ratio. Targets insulin resistance, androgen excess, and ovulatory dysfunction — the three core PCOS pathways.'
  },
  { id:'shoden2',
    name:'Unived KSM-66® Ashwagandha',
    strength:'600mg full-spectrum root extract (KSM-66®)',
    url:'https://www.unived.com/products/ksm-66',
    markers:['cortisol','tsh','thyroid','stress','dheas','testosterone'],
    why:'KSM-66® is the most clinically studied ashwagandha extract — 22+ human trials. Full-spectrum root-only extract. Validated for cortisol reduction, stress, sleep, and testosterone support.'
  }
];


// ── SHOPIFY CATALOGUE SYNC ──────────────────────────────────────────────
// Fetches live product catalogue via Storefront API at page load.
// Only products tagged with bw:* are included.
// Falls back silently to hardcoded BW_PRODUCTS if fetch fails.
// Set SHOPIFY_DOMAIN to your .myshopify.com domain to activate.

var SHOPIFY_TOKEN  = 'd43dcebd5bb903a518e203ad2ef89706';
var SHOPIFY_DOMAIN = 'unvied.myshopify.com'; // SET THIS once you confirm the myshopify.com subdomain

var BW_TAG_MAP = {
  'bw:vitamin_d':   ['vitamin d','25-oh','25oh','25 hydroxy','calcidiol'],
  'bw:b12':         ['b12','vitamin b12','cobalamin','methylmalonic'],
  'bw:iron':        ['ferritin','haemoglobin','hemoglobin','iron','hb','mchc','mcv','tibc','serum iron','rbc','transferrin'],
  'bw:magnesium':   ['magnesium','rbc magnesium','serum magnesium'],
  'bw:omega3':      ['triglycerides','ldl','hdl','cholesterol','tg','omega','dha','lipid'],
  'bw:ashwagandha': ['cortisol','tsh','thyroid stimulating','stress','dheas'],
  'bw:zinc':        ['zinc','serum zinc','testosterone','free testosterone'],
  'bw:vitamin_c':   ['vitamin c','ascorbic','crp','c-reactive','esr'],
  'bw:coq10':       ['ldl','cholesterol','statin','cardiovascular','coq10'],
  'bw:curcumin':    ['crp','c-reactive','esr','inflammatory','uric acid','joint'],
  'bw:biotin':      ['biotin','hair','nail'],
  'bw:pcos':        ['insulin','homa','lh','fsh','amh','testosterone','pcos','androgen','dheas']
};

var BW_TAG_WHY = {
  'bw:vitamin_d':   'D3 corrects deficiency; K2 directs calcium to bones rather than arteries.',
  'bw:b12':         'Methylcobalamin is the neurologically active form — superior absorption and retention vs cyanocobalamin.',
  'bw:iron':        'Ferrochel bisglycinate chelate is the most bioavailable, non-constipating form of supplemental iron.',
  'bw:magnesium':   'Non-buffered glycinate chelate — most absorbable form, supports sleep and stress without laxative effect.',
  'bw:omega3':      'Algae-sourced DHA — the original biosource fish use themselves. No heavy metal accumulation risk.',
  'bw:ashwagandha': 'Clinically validated for cortisol reduction, stress adaptation, and thyroid support at this extract potency.',
  'bw:zinc':        'Zinc citrate is highly bioavailable; critical for testosterone synthesis, immune function, and wound healing.',
  'bw:vitamin_c':   'Whole-food Vitamin C — enhances non-haem iron absorption when taken simultaneously.',
  'bw:coq10':       'Statins deplete CoQ10; fermented CoQ10 supports cardiovascular health and cellular energy production.',
  'bw:curcumin':    'Standardised curcuminoids inhibit COX-2 inflammatory pathways — paired with CoQ10 in CurQ10.',
  'bw:biotin':      'Targets hair follicle and nail keratin synthesis with supporting micronutrients.',
  'bw:pcos':        'Validated 40:1 myo:D-chiro inositol ratio addresses insulin resistance and androgen excess.'
};

// Maps Shopify bw:* tags → canonical BW_PRODUCTS IDs (used to overlay live URLs onto sc_map)
var BW_TAG_TO_PROD_ID = {
  'bw:vitamin_d':   ['d3k2', 'b12d3'],
  'bw:b12':         ['b12d3'],
  'bw:iron':        ['iron'],
  'bw:magnesium':   ['mag'],
  'bw:omega3':      ['omega3'],
  'bw:ashwagandha': ['ashwag', 'shoden2'],
  'bw:zinc':        ['zinc'],
  'bw:coq10':       ['curq10'],
  'bw:curcumin':    ['curq10'],
  'bw:biotin':      ['biotin'],
  'bw:pcos':        ['pcos']
};

// Populated by bwLoadShopifyCatalogue — maps BW_PRODUCTS id → live Shopify product URL + title
var BW_LIVE_URL_MAP = {};

function bwLoadShopifyCatalogue() {
  if (!SHOPIFY_DOMAIN || !SHOPIFY_TOKEN) return;

  var gql = '{ products(first: 250) { edges { node { title handle tags onlineStoreUrl variants(first: 1) { edges { node { title } } } } } } }';

  fetch('https://' + SHOPIFY_DOMAIN + '/api/2026-04/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SHOPIFY_TOKEN
    },
    body: JSON.stringify({ query: gql })
  })
  .then(function(r) { return r.ok ? r.json() : null; })
  .then(function(data) {

    if (!data || !data.data || !data.data.products) return;
    var edges = data.data.products.edges;
    var count = 0;
    edges.forEach(function(edge) {
      var node = edge.node;
      var bwTags = (node.tags || []).filter(function(t) { return t.indexOf('bw:') === 0; });
      if (bwTags.length === 0) return;

      var liveUrl = node.onlineStoreUrl || ('https://unived.com/products/' + node.handle);
      var strength = '';
      if (node.variants && node.variants.edges && node.variants.edges[0]) {
        var vt = node.variants.edges[0].node.title;
        if (vt && vt !== 'Default Title') strength = vt;
      }

      bwTags.forEach(function(tag) {
        var ids = BW_TAG_TO_PROD_ID[tag] || [];
        ids.forEach(function(id) {
          if (!BW_LIVE_URL_MAP[id]) {
            BW_LIVE_URL_MAP[id] = { url: liveUrl, name: node.title, strength: strength };
            count++;
          }
        });
      });
    });

    if (count > 0) {
      console.log('[Unived] Shopify sync: mapped ' + count + ' live product URLs');
    }
  })
  .catch(function() {
    console.log('[Unived] Shopify sync unavailable — using built-in catalogue');
  });
}

bwLoadShopifyCatalogue();
// ── END SHOPIFY CATALOGUE SYNC ──────────────────────────────────────────

// ── SYSTEM PROMPT — returns strict JSON ──────────────────────────
const BW_SYSTEM = `You are a medical data extraction AI. Your sole task is to read a blood test report and return a JSON object. Return ONLY valid JSON — no preamble, no explanation, no markdown fences.

Return this exact structure:
{
  "patient": { "name": "string or null", "age": "string or null", "gender": "string or null", "date": "string or null", "lab": "string or null" },
  "exec_summary": "3-5 sentence plain-English executive summary for the patient — overall picture, top 2-3 findings, what to prioritise. No medical jargon. Written like a knowledgeable friend summarising the report.",
  "summary": "1 sentence technical summary of key findings",
  "markers": [
    {
      "name": "exact marker name from report",
      "value": "numeric value as string",
      "unit": "unit string",
      "low": "reference low as string",
      "high": "reference high as string",
      "status": "normal|low|high|critically_low|critically_high",
      "category": "one of: vitamins|minerals|blood_count|metabolic|lipids|thyroid|hormones|liver|kidney|inflammation|other",
      "note": "1 sentence clinical significance if status is not normal, else empty string"
    }
  ],
  "critical": ["list of marker names that need urgent physician review — empty array if none"],
  "recommendations": [
    {
      "product_id": "one of: d3k2|b12d3|iron|mag|omega3|ashwag|shoden2|zinc|curq10|biotin|pcos",
      "marker": "the specific marker name driving this recommendation",
      "marker_value": "the value seen",
      "rationale": "1-2 sentences: why this marker warrants this supplement, what the evidence says"
    }
  ],
  "normal_note": "If overall report is normal, a reassuring 1-sentence note. Otherwise empty string."
}

STRICT RULES:
- Extract every marker you can read from the report, even if status is normal
- status 'critically_low' = below 50% of lower reference limit, or clinically urgent
- status 'critically_high' = above 150% of upper reference limit, or clinically urgent  
- recommendations: maximum 5, only where marker status is low/high/critically_low/critically_high
- product_id must exactly match one of the 12 IDs listed above
- Never recommend a product for a normal marker
- Return valid JSON only — the consuming code will JSON.parse() this directly
- Keep all string values concise — max 200 characters per field. No markdown inside JSON strings.
- Use straight apostrophes only — never curly/smart quotes inside JSON strings
- Do not include newlines or tab characters inside JSON string values
- The exec_summary field: 3-5 sentences, plain English, no jargon, for a non-medical reader. Cover: (1) overall picture, (2) the 2-3 most important findings, (3) what to prioritise. Like a knowledgeable friend explaining the report`;

// ── STATUS helpers ────────────────────────────────────────────────
function bwStatusColor(status) {
  return {
    normal:          { bg:'#EEF5E8', text:'#2C6A00', label:'Normal' },
    low:             { bg:'#FFF4E0', text:'#7A4E00', label:'Low' },
    high:            { bg:'#FFF4E0', text:'#7A4E00', label:'High' },
    critically_low:  { bg:'#FEE2E2', text:'#C00000', label:'Critical — Low' },
    critically_high: { bg:'#FEE2E2', text:'#C00000', label:'Critical — High' }
  }[status] || { bg:'#F0F0EC', text:'#6B6868', label:'—' };
}

function bwCategoryLabel(cat) {
  return {
    vitamins:'Vitamins', minerals:'Minerals', blood_count:'Complete Blood Count',
    metabolic:'Metabolic', lipids:'Lipid Profile', thyroid:'Thyroid',
    hormones:'Hormones', liver:'Liver Function', kidney:'Kidney Function',
    inflammation:'Inflammation', other:'Other'
  }[cat] || cat;
}

// ── GAUGE bar renderer ────────────────────────────────────────────
function bwGauge(marker) {
  const val  = parseFloat(marker.value);
  const low  = parseFloat(marker.low);
  const high = parseFloat(marker.high);
  if (isNaN(val) || isNaN(low) || isNaN(high) || high <= low) return '';

  // Calculate percent position (clamp 0-100)
  const rangeSpan = high - low;
  const padding   = rangeSpan * 0.25; // 25% padding each side
  const min = low  - padding;
  const max = high + padding;
  const pct = Math.min(100, Math.max(0, ((val - min) / (max - min)) * 100));
  const lowPct  = ((low  - min) / (max - min)) * 100;
  const highPct = ((high - min) / (max - min)) * 100;

  const sc = bwStatusColor(marker.status);

  return `<div style="margin-top:10px">
    <div style="position:relative;height:8px;background:#F0F0EC;border-radius:4px;overflow:visible">
      <!-- Normal range highlight -->
      <div style="position:absolute;left:${lowPct}%;width:${highPct-lowPct}%;height:100%;background:#C8E0B8;border-radius:2px"></div>
      <!-- Value marker -->
      <div style="position:absolute;left:${pct}%;top:50%;transform:translate(-50%,-50%);width:14px;height:14px;border-radius:50%;background:${sc.text};border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.2);z-index:2"></div>
    </div>
    <div style="display:flex;justify-content:space-between;margin-top:5px">
      <span style="font-family:var(--mono);font-size:.64rem;color:var(--ink-muted)">${marker.low} ${marker.unit}</span>
      <span style="font-family:var(--mono);font-size:.64rem;color:var(--ink-muted)">${marker.high} ${marker.unit}</span>
    </div>
  </div>`;
}

// ── RENDER full report ────────────────────────────────────────────
var BW_ID_ALIAS = {
  'b12':      'b12d3',
  'curcumin': 'curq10',
  'coq10':    'curq10',
  'shoden':   'ashwag',
  'vitc':     null
};

function bwRenderReport(data) {
  // Build sc_map from hardcoded BW_PRODUCTS (IDs match AI output).
  // Overlay live URL/name/strength from Shopify sync where available.
  const sc_map = {};
  BW_PRODUCTS.forEach(function(p) {
    var live = BW_LIVE_URL_MAP[p.id];
    sc_map[p.id] = live ? Object.assign({}, p, live) : p;
  });

  // Group markers by category
  const cats = {};
  (data.markers || []).forEach(function(m) {
    const c = m.category || 'other';
    if (!cats[c]) cats[c] = [];
    cats[c].push(m);
  });
  const catOrder = ['blood_count','vitamins','minerals','metabolic','lipids','thyroid','hormones','liver','kidney','inflammation','other'];

  // Count statuses
  const critCount  = (data.markers||[]).filter(function(m){ return m.status==='critically_low'||m.status==='critically_high'; }).length;
  const warnCount  = (data.markers||[]).filter(function(m){ return m.status==='low'||m.status==='high'; }).length;
  const normCount  = (data.markers||[]).filter(function(m){ return m.status==='normal'; }).length;
  const totalCount = (data.markers||[]).length;

  let html = '';

  // ── PATIENT + SUMMARY BAR ──
  const p = data.patient || {};
  html += `<div style="background:var(--bg);border-bottom:1px solid var(--rule);padding:20px 24px;display:flex;gap:24px;flex-wrap:wrap;align-items:center">
    ${p.name ? `<div><span style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted)">Patient&nbsp;</span><span style="font-family:var(--sans);font-size:.88rem;font-weight:600;color:var(--ink)">${p.name}</span></div>` : ''}
    ${p.age  ? `<div><span style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted)">Age&nbsp;</span><span style="font-family:var(--sans);font-size:.88rem;color:var(--ink-soft)">${p.age}</span></div>` : ''}
    ${p.gender?`<div><span style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted)">Gender&nbsp;</span><span style="font-family:var(--sans);font-size:.88rem;color:var(--ink-soft)">${p.gender}</span></div>` : ''}
    ${p.date  ? `<div><span style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted)">Date&nbsp;</span><span style="font-family:var(--sans);font-size:.88rem;color:var(--ink-soft)">${p.date}</span></div>` : ''}
    ${p.lab   ? `<div><span style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted)">Lab&nbsp;</span><span style="font-family:var(--sans);font-size:.88rem;color:var(--ink-soft)">${p.lab}</span></div>` : ''}
  </div>`;

  // ── SCORE STRIP ──
  html += `<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:var(--rule);border-bottom:1px solid var(--rule)">
    <div style="background:#fff;padding:18px 20px;text-align:center">
      <div style="font-family:var(--sans);font-size:1.6rem;font-weight:700;color:var(--ink)">${totalCount}</div>
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-muted);margin-top:3px">Markers read</div>
    </div>
    <div style="background:#EEF5E8;padding:18px 20px;text-align:center">
      <div style="font-family:var(--sans);font-size:1.6rem;font-weight:700;color:#2C6A00">${normCount}</div>
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:#2C6A00;margin-top:3px">Normal</div>
    </div>
    <div style="background:#FFF4E0;padding:18px 20px;text-align:center">
      <div style="font-family:var(--sans);font-size:1.6rem;font-weight:700;color:#7A4E00">${warnCount}</div>
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:#7A4E00;margin-top:3px">Out of range</div>
    </div>
    <div style="background:${critCount>0?'#FEE2E2':'#fff'};padding:18px 20px;text-align:center">
      <div style="font-family:var(--sans);font-size:1.6rem;font-weight:700;color:${critCount>0?'#C00000':'var(--ink-muted)'}">${critCount}</div>
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:${critCount>0?'#C00000':'var(--ink-muted)'};margin-top:3px">Critical</div>
    </div>
  </div>`;

  // ── EXEC SUMMARY ──
  if (data.exec_summary || data.summary) {
    var execText = data.exec_summary || data.summary;
    html += '<div style="background:#fff;border-bottom:1px solid var(--rule);padding:28px 24px">';
    html += '<div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.14em;text-transform:uppercase;color:var(--accent);margin-bottom:14px">Plain English Summary</div>';
    html += '<p style="font-family:var(--serif);font-size:1.05rem;color:var(--ink);line-height:1.82;max-width:72ch">' + execText + '</p>';
    if (data.summary && data.exec_summary) {
      html += '<p style="font-family:var(--mono);font-size:.7rem;color:var(--ink-muted);margin-top:12px;padding-top:12px;border-top:1px solid var(--rule-soft)">' + data.summary + '</p>';
    }
    html += '</div>';
  }

  // ── CRITICAL ALERTS ──
  if ((data.critical||[]).length > 0) {
    html += `<div style="padding:16px 24px;background:#FEE2E2;border-bottom:2px solid #C00000;display:flex;gap:14px;align-items:flex-start">
      <span style="font-size:1.2rem;flex-shrink:0">⚠️</span>
      <div>
        <div style="font-family:var(--sans);font-size:.88rem;font-weight:700;color:#7A0000;margin-bottom:5px">Requires physician review</div>
        <div style="font-family:var(--serif);font-size:.88rem;color:#7A0000;line-height:1.6">The following markers need medical attention before you start any supplement: <strong>${data.critical.join(', ')}</strong>. Please consult your doctor.</div>
      </div>
    </div>`;
  }

  // ── NORMAL NOTE ──
  if (data.normal_note) {
    html += `<div style="padding:16px 24px;background:#EEF5E8;border-bottom:1px solid #C8E0B8;display:flex;gap:12px;align-items:center">
      <span style="color:var(--accent);font-size:1.1rem">✓</span>
      <p style="font-family:var(--serif);font-size:.9rem;color:#2C6A00">${data.normal_note}</p>
    </div>`;
  }

  // ── MARKERS BY CATEGORY ──
  html += `<div style="padding:24px;background:var(--bg);border-bottom:1px solid var(--rule)">
    <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.14em;text-transform:uppercase;color:var(--accent);margin-bottom:16px">Your Biomarkers</div>`;

  catOrder.forEach(function(cat) {
    if (!cats[cat] || cats[cat].length === 0) return;
    html += `<div style="margin-bottom:20px">
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-muted);margin-bottom:8px;padding-bottom:6px;border-bottom:1px solid var(--rule)">${bwCategoryLabel(cat)}</div>
      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:8px">`;

    cats[cat].forEach(function(m) {
      const sc = bwStatusColor(m.status);
      const isBad = m.status !== 'normal';
      html += `<div style="background:#fff;border:1px solid ${isBad ? sc.text+'44' : 'var(--rule)'};padding:14px 16px;${isBad?'border-left:3px solid '+sc.text:''}">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:4px">
          <div style="font-family:var(--sans);font-size:.82rem;font-weight:600;color:var(--ink);line-height:1.3">${m.name}</div>
          <span style="font-family:var(--mono);font-size:.62rem;letter-spacing:.06em;text-transform:uppercase;background:${sc.bg};color:${sc.text};padding:2px 7px;flex-shrink:0;margin-left:6px">${sc.label}</span>
        </div>
        <div style="font-family:var(--sans);font-size:1.1rem;font-weight:700;color:${isBad?sc.text:'var(--ink)'}">${m.value} <span style="font-size:.72rem;font-weight:400;color:var(--ink-muted)">${m.unit}</span></div>
        <div style="font-family:var(--mono);font-size:.65rem;color:var(--ink-muted);margin-top:2px">Ref: ${m.low} – ${m.high} ${m.unit}</div>
        ${bwGauge(m)}
        ${m.note ? `<div style="font-family:var(--serif);font-size:.78rem;color:${sc.text};margin-top:8px;line-height:1.5">${m.note}</div>` : ''}
      </div>`;
    });

    html += `</div></div>`;
  });
  html += `</div>`;

  // ── PRODUCT RECOMMENDATIONS ──
  if ((data.recommendations||[]).length > 0) {
    html += `<div style="padding:24px;background:#fff;border-top:1px solid var(--rule)">
      <div style="font-family:var(--mono);font-size:.65rem;letter-spacing:.14em;text-transform:uppercase;color:var(--accent);margin-bottom:6px">Unived Supplement Recommendations</div>
      <p style="font-family:var(--serif);font-size:.84rem;color:var(--ink-muted);margin-bottom:16px">Based on the out-of-range markers in your report. Consult your doctor before starting any supplement.</p>
      <div style="display:flex;flex-direction:column;gap:10px">`;

    data.recommendations.forEach(function(rec) {
      var pid = rec.product_id;
      if (BW_ID_ALIAS.hasOwnProperty(pid)) pid = BW_ID_ALIAS[pid];
      if (!pid) return;
      const prod = sc_map[pid];
      if (!prod) return;
      html += `<div style="border:1px solid var(--rule);padding:16px 18px;display:grid;grid-template-columns:1fr auto;gap:16px;align-items:start">
        <div>
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:5px">
            <div style="font-family:var(--sans);font-size:.9rem;font-weight:700;color:var(--ink)">${prod.name}</div>
          </div>
          <div style="font-family:var(--mono);font-size:.7rem;color:var(--accent);margin-bottom:8px">${prod.strength}</div>
          <div style="font-family:var(--mono);font-size:.68rem;letter-spacing:.08em;text-transform:uppercase;color:var(--ink-muted);margin-bottom:4px">Responding to: <strong style="color:var(--ink)">${rec.marker}</strong> — ${rec.marker_value}</div>
          <div style="font-family:var(--serif);font-size:.84rem;color:var(--ink-soft);line-height:1.65">${rec.rationale}</div>
          <div style="font-family:var(--serif);font-size:.78rem;color:var(--ink-muted);margin-top:5px;font-style:italic">${prod.why}</div>
        </div>
        <button onclick="window.open('${prod.url}','_blank')" style="background:var(--accent);color:#fff;font-family:var(--mono);font-size:.65rem;letter-spacing:.08em;text-transform:uppercase;padding:8px 14px;border:none;cursor:pointer;white-space:nowrap;transition:opacity .15s;flex-shrink:0" onmouseover="this.style.opacity='.8'" onmouseout="this.style.opacity='1'">Shop →</button>
      </div>`;
    });

    html += `</div></div>`;
  } else if (!data.normal_note) {
    html += `<div style="padding:20px 24px;background:#fff;border-top:1px solid var(--rule)">
      <p style="font-family:var(--serif);font-size:.9rem;color:var(--ink-muted)">No specific supplement recommendations based on the values in this report.</p>
    </div>`;
  }

  return html;
}

// ── MAIN analyse function ─────────────────────────────────────────
// ════════════════════════════════════════════════════════════════
// Bloodwork analyser — File API flow (fast, like the Gemini web app)
//
// WIRING REQUIRED (one line): in your file-select handler, right where
// you set `bwSelectedFile = file;`, also call:
//     bwPrepareUpload(file);
// That kicks off the upload in the background while the user is still
// looking at the page, so clicking "Analyse" only waits on generation.
// (If you skip it, bwAnalyse still uploads on demand — just not as fast.)
// ════════════════════════════════════════════════════════════════

var bwUpload = { promise: null, forFile: null, uri: null, name: null, mime: null };

function bwApi(path) {
  return (BW_PROXY_URL || '').replace(/\/+$/, '') + path;
}

// Start (or restart) a background upload for the given file.
window.bwPrepareUpload = function(file) {
  bwUpload = { promise: null, forFile: file, uri: null, name: null, mime: null };
  bwUpload.promise = (async function() {
    const mime = bwMime(file);
    const resp = await fetch(bwApi('/upload') + '?name=' + encodeURIComponent(file.name || 'bloodwork'), {
      method: 'POST',
      headers: { 'Content-Type': mime },
      body: file
    });
    if (!resp.ok) {
      const e = await resp.json().catch(function(){ return {}; });
      throw new Error(e.error ? e.error.message : 'Upload failed (' + resp.status + ')');
    }
    const data = await resp.json();
    if (!data.fileUri) throw new Error('Upload did not return a file reference.');
    bwUpload.uri  = data.fileUri;
    bwUpload.name = data.fileName;
    bwUpload.mime = data.mimeType || mime;
    return data;
  })();
  return bwUpload.promise;
};

window.bwAnalyse = async function() {
  if (!bwSelectedFile) return;
  document.getElementById('bwUploadZone') && (document.getElementById('bwUploadZone').style.display = 'none');
  document.getElementById('bwFileRow').style.display = 'none';
  document.getElementById('bwBtn').style.display = 'none';
  document.getElementById('bwLoadingState').style.display = 'block';
  document.getElementById('bwResultState').style.display = 'none';
  document.getElementById('bwErrorState').style.display = 'none';

  // Pull visible (non-thought) text out of one Gemini response object.
  function bwExtractText(obj) {
    var t = '';
    var parts = obj && obj.candidates && obj.candidates[0] &&
                obj.candidates[0].content && obj.candidates[0].content.parts;
    if (Array.isArray(parts)) {
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (p && typeof p.text === 'string' && !p.thought) t += p.text;
      }
    }
    return t;
  }

  try {
    // Reuse the background upload if it was started on file-select;
    // otherwise upload now.
    if (!(bwUpload.promise && bwUpload.forFile === bwSelectedFile)) {
      window.bwPrepareUpload(bwSelectedFile);
    }
    await bwUpload.promise;

    const parts = [
      { fileData: { fileUri: bwUpload.uri, mimeType: bwUpload.mime } },
      { text: 'Extract all biomarker data from this blood test report and return the JSON structure as instructed. Return ONLY valid JSON.' }
    ];

    const resp = await fetch(bwApi(''), {   // root path = analyze
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        systemInstruction: { parts: [{ text: BW_SYSTEM }] },
        contents: [{ role: 'user', parts: parts }],
        generationConfig: {
          maxOutputTokens: 32000,
          responseMimeType: 'application/json',
          mediaResolution: 'MEDIA_RESOLUTION_LOW', // ~280 tokens/page — big speedup on a 50-page PDF
          thinkingConfig: { thinkingLevel: 'low' }
        }
      })
    });

    if (!resp.ok) {
      const err = await resp.json().catch(function(){ return {}; });
      throw new Error(err.error ? err.error.message : 'API error ' + resp.status);
    }

    // ── Read the whole body, then parse whatever shape it is ──────────
    const reader  = resp.body.getReader();
    const decoder = new TextDecoder();
    let full = '';
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      full += decoder.decode(value, { stream: true });
    }
    full += decoder.decode();

    let rawText = '';
    if (/(^|\n)\s*data:/.test(full)) {
      const lines = full.split('\n');
      for (let i = 0; i < lines.length; i++) {
        const trimmed = lines[i].trim();
        if (!trimmed.startsWith('data:')) continue;
        const payload = trimmed.slice(5).trim();
        if (!payload || payload === '[DONE]') continue;
        try { rawText += bwExtractText(JSON.parse(payload)); } catch (e) {}
      }
    } else {
      try {
        const parsed = JSON.parse(full.trim());
        if (Array.isArray(parsed)) {
          for (let i = 0; i < parsed.length; i++) rawText += bwExtractText(parsed[i]);
        } else {
          rawText += bwExtractText(parsed);
        }
      } catch (e) {
        const lines = full.split('\n');
        for (let i = 0; i < lines.length; i++) {
          const ln = lines[i].trim();
          if (!ln) continue;
          try { rawText += bwExtractText(JSON.parse(ln)); } catch (e2) {}
        }
      }
    }

    if (!rawText) {
      var fr = (full.match(/"finishReason"\s*:\s*"([A-Z_]+)"/) || [])[1] || 'UNKNOWN';
      console.error('Bloodwork: empty extraction. finishReason=' + fr + '. Raw payload (first 1500 chars):\n', full.slice(0, 1500));
      var hint;
      if (fr === 'MAX_TOKENS') {
        hint = 'The model used up its output budget before finishing (MAX_TOKENS). Try a higher maxOutputTokens or thinkingLevel "minimal".';
      } else if (fr === 'SAFETY' || fr === 'PROHIBITED_CONTENT' || fr === 'RECITATION') {
        hint = 'The response was blocked (' + fr + ').';
      } else {
        hint = 'No text was returned (finishReason ' + fr + ').';
      }
      throw new Error(hint);
    }

    // ── Stage 1: strip markdown fences ──────────────────────────────
    rawText = rawText.replace(/^```json\s*/i,'').replace(/^```\s*/,'').replace(/\s*```$/,'').trim();

    // ── Stage 2: extract JSON object if surrounded by prose ──────────
    var firstBrace = rawText.indexOf('{');
    var lastBrace  = rawText.lastIndexOf('}');
    if (firstBrace >= 0 && lastBrace > firstBrace) {
      rawText = rawText.slice(firstBrace, lastBrace + 1);
    }

    // ── Stage 3: fix common LLM JSON problems ────────────────────────
    rawText = rawText.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, ' ');
    rawText = rawText.replace(/"((?:[^"\\]|\\.)*)"/g, function(m, inner) {
      return '"' + inner.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t') + '"';
    });

    // ── Stage 4: parse ────────────────────────────────────────────────
    var reportData;
    try {
      reportData = JSON.parse(rawText);
    } catch(parseErr) {
      try {
        var cleaned = rawText
          .replace(/,\s*([\]}])/g, '$1')
          .replace(/([{,])\s*,/g, '$1');
        reportData = JSON.parse(cleaned);
      } catch(e2) {
        var fr2 = (full.match(/"finishReason"\s*:\s*"([A-Z_]+)"/) || [])[1] || 'UNKNOWN';
        console.error('Bloodwork: JSON parse failed. finishReason=' + fr2 +
          ', length=' + rawText.length + '. Last 400 chars:\n', rawText.slice(-400));
        if (fr2 === 'MAX_TOKENS') {
          throw new Error('The report was long enough that the response was cut off before the JSON finished. Raise maxOutputTokens further, or set thinkingLevel to "minimal".');
        }
        throw new Error('The analysis returned malformed data. Please try again, or upload an image (JPG/PNG) instead of a PDF.');
      }
    }

    console.log('[Bloodwork] recommendations:', JSON.stringify(reportData.recommendations));
    document.getElementById('bwLoadingState').style.display = 'none';
    document.getElementById('bwResultBody').innerHTML = bwRenderReport(reportData);
    document.getElementById('bwResultState').style.display = 'block';

    // ── Cleanup: delete the uploaded file (fire-and-forget) ───────────
    if (bwUpload.name) {
      fetch(bwApi('/delete') + '?name=' + encodeURIComponent(bwUpload.name), { method: 'POST' }).catch(function(){});
    }
    bwUpload = { promise: null, forFile: null, uri: null, name: null, mime: null };

  } catch(err) {
    document.getElementById('bwLoadingState').style.display = 'none';
    let msg = err.message || 'Something went wrong. Please try again.';
    if (msg.toLowerCase().includes('failed to fetch') || msg.toLowerCase().includes('network')) {
      msg = 'Connection error. Ensure you are connected to the internet. If you opened this file from your desktop, try opening it in Chrome or Firefox instead.';
    }
    document.getElementById('bwErrorMsg') && (document.getElementById('bwErrorMsg').textContent = msg);
    document.getElementById('bwErrorState').style.display = 'block';
    document.getElementById('bwUploadZone') && (document.getElementById('bwUploadZone').style.display = '');
    document.getElementById('bwFileRow').style.display = 'flex';
    document.getElementById('bwBtn').style.display = '';
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
